export default {
  type: {
    label: "Type",
    options: {
      text: "Text",
      choice: "Choice",
      perm: "Perm",
      list: "List",
      link: "Link",
    },
  },
};
